import { useState } from 'react';
import { useWindowResize } from './hooks/useWindowResize';

const MOBILE_WIDTH_BREAKPOINT = 640;

export const isMobile = () => {
  return document.body.scrollWidth < MOBILE_WIDTH_BREAKPOINT;
};

export const useIsMobile = () => {
  const [isMobileDevice, setIsMobileDevice] = useState(isMobile());

  useWindowResize(() => setIsMobileDevice(isMobile()), 500);

  return isMobileDevice;
};
